module.exports = __webpack_public_path__ + "img/节点权限.a9bee095.svg";